import Classify from '@utils/Classify';
import React, { HTMLAttributes, useEffect, useRef, useState } from 'react';

type Props = HTMLAttributes<HTMLDivElement>;

const Fader: React.FC<Props> = (props) => {

  const [loaded, setLoaded] = useState<boolean>(false);
  const columnRef = useRef(null);

  useEffect(() => {
    setLoaded(true);
  }, []);

  return (
    <div {...props}
      style={{
        transition: 'opacity 400ms linear'
      }}
      className={'resizer fader' +
        Classify.addClassName(!!props.children && loaded, 'loaded')
      }>
      <div ref={columnRef} style={{ display: 'flow-root' }} >
        {props.children}
      </div>
    </div >
  );

}

export default Fader;